import { Storybook } from "@tento-ui/ui/storybook";
import { ChatPlayground } from "./chat-playground";

/** The whole matrix in one card: every library dataset under every look
 * under both renderers, driven by the simulator — no server, no product
 * plugins. A host's own blocks are the host's storybook to show. */
export class ChatPlaygroundStoryBook extends Storybook.Default {
  title(): string {
    return "Chat · playground";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Library fixtures × looks × renderers (simulated transport)",
        render: () => {
          const $p = ChatPlayground.makeWith({});
          $p.style.height = "720px";
          return $p;
        },
      },
    ];
  }
}
